import $ from 'jquery';

$(() => {
    $('a[href*="#parking"], a[href*="#parking_row"], a[href*="#flights"]').on('click', function(e) {
        const id = $(this.hash);
        const $id = $(id);
        if (!id || $id.length === 0) {
            return;
        }
        e.preventDefault();

        const headerHeight = $("#masthead .menu-container").outerHeight();
        const pos = $id.offset().top;
        $('body, html').animate({scrollTop: pos - headerHeight});
    });
});
